import { createBrowserRouter } from 'react-router-dom';
import { Layout } from '../components/Layout';
import {DiagnosisSession } from '../pages/DiagnosisSession';
import { HomePage } from '../pages/HomePage';
import {DiagnosticPage}  from '../pages/DiagnosticPage';
import AdminPage from '../pages/AdminPage';
import { CaseManagementPage } from '../pages/CaseManagementPage';
import { LoginPage } from '../pages/LoginPage';
import { authLoader } from './authLoader';
import { adminLoader } from './adminLoader';

// Still need to change ideally the home page should be the first page that is loaded
export const router = createBrowserRouter([
  {
    path: '/',
    loader: authLoader,
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomePage />
      },
      {
        path: 'diagnostic',
        element: <DiagnosticPage/>
      },
      {
        path: 'cases',
        loader: adminLoader,
        element: <CaseManagementPage />
      },
      {
        path: 'admin',
        loader: adminLoader,
        element: <AdminPage />
      }
    ]
  },{
    path: '/diagnostic/:caseId/:fieldId/:sessionDetails',
    loader: authLoader,
    element: <DiagnosisSession/>
  },
  {
    path: '/login',
    element: <LoginPage />
  }
]);
